<template>
    <SearchBar
        :loading="loading"
        :showCloseButton="showCloseButton"
        @submit="handleSubmit"
        @close="handleClose"
    >
        <template #inputs>
            <div
                class="w-full grow h-10 pl-4 pr-3 py-2.5 bg-white justify-start items-center gap-2 flex rounded"
                :class="{
                    'ring-red-600 ring-1':
                        !activeAirport?.name && errors.includes('airportCode'),
                }"
            >
                <div
                    class="w-5 h-5 flex align-center text-[#808080]"
                    :class="{
                        'text-red-500':
                            !activeAirport?.name &&
                            errors.includes('airportCode'),
                    }"
                >
                    <Icon icon="search" />
                </div>
                <LoungesAutoSuggest
                    :allSuggestions="airports"
                    :recentSearches="recentSearches"
                    :inputValue="activeAirport?.name"
                    valueKey="code"
                    displayKey="name"
                    @select="(v) => handleSubmit(v)"
                    @submit="(v) => handleSubmit(v)"
                />
                <SearchFormValidationErrors
                    :errors="errors"
                    errorType="destination"
                    errorMessage="Please enter a destination"
                />
            </div>
        </template>
        <template #buttons>
            <div
                class="w-full md:w-auto flex items-center pt-3 md:pt-0"
                :class="{
                    'justify-between': showCloseButton,
                    'justify-end': !showCloseButton,
                }"
                v-if="showCloseButton"
            >
                <button
                    type="button"
                    @click="$emit('close')"
                    :disabled="loading"
                    class="md:hidden px-4 py-2.5 bg-slate-200 rounded justify-center items-center gap-2 flex text-slate-800 hover:bg-slate-300 active:bg-slate-400 focus:outline-slate-200 focus:shadow disabled:opacity-50 disabled:bg-slate-600"
                >
                    <div class="text-sm font-medium leading-tight">Close</div>
                </button>
            </div>
        </template>
    </SearchBar>
</template>

<script>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useLoungesStore } from '@/store/lounges';
import ClearInputButton from '@/components/ui/clear-input-button/clear-input-button.vue';
import EmptyState from '@/components/ui/empty-state/empty-state.vue';
import Icon from '@/components/ui/icon/icon.vue';
import LoungesAutoSuggest from '@/components/tools/lounges/lounges-search/lounges-autosuggest/lounges-autosuggest.vue';
import SearchBar from '@/components/ui/inputs/search-bar/search-bar.vue';
import SearchFormValidationErrors from '@/components/hotels/search/search-form-validation-errors/search-form-validation-errors.vue';
import RecentSearches from '@/components/tools/recent-searches/recent-searches.vue';
export default {
    components: {
        ClearInputButton,
        EmptyState,
        Icon,
        LoungesAutoSuggest,
        RecentSearches,
        SearchBar,
        SearchFormValidationErrors,
    },
    props: {
        showCloseButton: {
            type: Boolean,
            default: false,
        },
    },
    setup(_, { emit }) {
        const router = useRouter();
        const loungesStore = useLoungesStore();
        const errors = ref([]);
        const { activeAirport, airports, loading, recentSearches } =
            storeToRefs(loungesStore);
        const { getRecentSearches, searchLounges, setActiveAirport } =
            loungesStore;

        const handleClose = () => {
            emit('closeForm');
        };

        const handleSubmit = async (airportObj) => {
            setActiveAirport(airportObj);

            if (!errors.value.length) {
                await search();
            }
        };

        const search = async () => {
            searchLounges();

            router.push(`/lounges/search?airport=${activeAirport.value.code}`);
        };

        getRecentSearches();

        return {
            activeAirport,
            airports,
            errors,
            handleClose,
            handleSubmit,
            loading,
            recentSearches,
            setActiveAirport,
        };
    },
};
</script>
